import { toast } from "react-toastify";
import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import { setToaster, showToaster } from "../utils/helpers";
import * as API from "../utils/apiPath";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";

export function leadChecklistDataSuccess(leadChecklistData) {
    return { type: types.LOAD_LEAD_CHECKLIST_DATA_SUCCESS, leadChecklistData };
}

export function sourceOfLeadDataSuccess(sourceData) {
  return { type: types.GET_SOURCE_OF_LEAD_DATA_SUCCESS, sourceData };
}

export function masterProfileDataSuccess(masterProfileData) {
  return { type: types.GET_LEAD_MASTER_PROFILE, masterProfileData };
}

export function leadsDataSuccess(leadsData) {
  return { type: types.LOAD_LEADS_DATA_SUCCESS, leadsData };
}

export function leadInfoSuccess(leadInfo) {
  return { type: types.LOAD_LEAD_INFO_SUCCESS, leadInfo };
}

export function leadProfileInfoSuccess(leadProfileInfo) {
  return { type: types.LOAD_LEAD_PROFILE_DATA_SUCCESS, leadProfileInfo };
}

// export function communicationInfoSuccess(leadCommunicationInfo) {
 // return { type: types.LOAD_COMMUNICATON_INFO_SUCCESS, leadCommunicationInfo };
// }

export function interactionTypeDataSuccess(interactionTypeData) {
  return { type: types.LOAD_INTERACTION_TYPE, interactionTypeData };
}

export function leadStatusDataSuccess(leadStatusData) {
  return { type: types.LOAD_LEAD_STATUS, leadStatusData };
}
export function leadCreateSuccess(createLead) {
  return { type: types.LEAD_CREATE_STATUS, createLead };
}

export function checklistsDataSuccess(checklistsData) {
  return { type: types.LOAD_CHECKLISTS_DATA_SUCCESS, checklistsData };
}

export function sourceLeadInfoSuccess(sourceLeadInfo) {
  return { type: types.LOAD_SOURCE_LEAD_INFO_SUCCESS, sourceLeadInfo };
}

export function leadStatusInfoSuccess(leadStatusInfo) {
  return { type: types.LOAD_LEAD_STATUS_INFO_SUCCESS, leadStatusInfo };
}

const createLead = (params,push) => {
  return async function (dispatch) {
    await agent
      .post(API.CREATE_LEAD, params)
      .then((response) => {  

        console.log("========createLead : start=========");
        console.log(response);
        console.log("========createLead : end=========");
        
        if (response.status === 200 || response.status === 201) {
          if (!response.data.success) {
            setToaster(response.data.message);
          }
          if (response.data.status === 422 || response.data.status === 201) {
            setToaster(response.data.message);
          }
          if (response.data.success) {
            setToaster(response.data.message);
            push("/dashboard/create-lead"); 
            dispatch(leadCreateSuccess(response.data));
            // setToaster(response.data.message);
            // push("/dashboard/create-lead");
          }
        } else{ 
            setToaster(response.data.message);
        } 
      })
      .catch((error) => {
        throw error;
      });
  };
}

// my code start

const leadStatusDataAllDropdown = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;
      if (returnVal) { 
        response = await agent.post(API.GET_LEAD_STATUS_ALL, params);
      } else {
        response = await agent.post(API.GET_LEAD_STATUS_ALL, params);
      }
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }
      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
}




// my code end

const addEditLead = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_LEAD, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const editLead = (params,push) => {
  return async function (dispatch) {
    await agent
      .post(API.CREATE_LEAD, params)
      .then((response) => {  
 
        if (response.status === 200 || response.status === 201) {
          if (!response.data.success) {
            setToaster(response.data.message);
          }
          if (response.data.status === 422 || response.data.status === 201) {
            setToaster(response.data.message);
          }
          if (response.data.success) {
            setToaster(response.data.message);
            const encodedId = btoa(String(response.data.lead_id));
            push(`/dashboard/edit-lead/${encodedId}`); 
          }
        } else{ 
            setToaster(response.data.message);
        } 
      })
      .catch((error) => {
        throw error;
      });
  };
}

/* const sourceData  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_SOURCE_OF_LREADS, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(sourceOfLeadDataSuccess(response.data.data));
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
} */

const sourceData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_SOURCE_OF_LREADS, params);
      } else {
        response = await agent.post(API.GET_SOURCE_OF_LREADS, params);
        
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(sourceOfLeadDataSuccess(response.data.data));
          }
        }
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

/* const masterProfileData  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_LEAD_PROFILE, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(masterProfileDataSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
} */

const masterProfileData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LEAD_PROFILE, params);
      } else {
        response = await agent.post(API.GET_LEAD_PROFILE, params);
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const createLeadCommunication = (params,push) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_LEAD_COMMUNICATION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const createLeadQualificationChecklist = (params,push) => {
  return async function (dispatch) {
    await agent
      .post(API.CREATE_LEAD_QUALIFICATION_CHECKLIST, params)
      .then((response) => {  

        console.log("========createLeadQualificationChecklist : start=========");
        console.log(response);
        console.log("========createLeadQualificationChecklist : end=========");
        
        if (response.status === 200 || response.status === 201) {
          if (!response.data.success) {
            setToaster(response.data.message);
          }
          if (response.data.status === 422 || response.data.status === 201) {
            setToaster(response.data.message);
          }
          if (response.data.success) {
            setToaster(response.data.message); 
            push("/dashboard"); 
          }
        } else{ 
            setToaster(response.data.message);
        } 
      })
      .catch((error) => {
        throw error;
      });
  };
}

const createQualificationChecklist = (params,push) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CU_QUALIFICATION_CHECKLIST, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const leadChecklistData  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_LEAD_CHECKLIST, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(leadChecklistDataSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
}

const leadsData  = (params, preloader = true, returnVal = false) => {
  
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    }

    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LEADS, params);
      } else {
        response = await agent.post(API.GET_LEADS, params);
        
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(leadsDataSuccess(response.data.data));
          }
        }
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
}

/*
const leadInfo  = (params) => {
  return async function (dispatch) { 
    dispatch(toggleNetworkRequestStatus(true));
    await agent
      .post(API.GET_LEADS, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(toggleNetworkRequestStatus(false));
          if (response.data.status === 200) {
             dispatch(leadInfoSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      });
  };
} */

const leadInfo = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LEADS, params);
      } else {
        response = await agent.post(API.GET_LEADS, params);
        
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(leadInfoSuccess(response.data.data));
          }
        }
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const leadCommunicationInfo  = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) { 
    const loader = preloader ? dispatch(toggleNetworkRequestStatus(true)) : '';
    try {
      const response = await agent.post(API.GET_COMMUNICATION, params);
      const loader = preloader ? dispatch(toggleNetworkRequestStatus(false)) : '';
      return response;
    } catch (error) {
      const loader = preloader ? dispatch(toggleNetworkRequestStatus(false)) : '';
      throw error;
    } 
  };
}

const interactionTypeData  = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) { 
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    await agent
      .post(API.GET_INTERACTION_TYPE, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (preloader) {
            dispatch(toggleNetworkRequestStatus(false));
          } 
          if (response.data.status === 200) {
             dispatch(interactionTypeDataSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        } 
        throw error;
      });
  };
}

// const leadStatusData  = (params) => {
//   return async function (dispatch) { 
//     dispatch(toggleNetworkRequestStatus(true));
//     await agent
//       .post(API.GET_LEAD_STATUS, params)
//       .then((response) => {
//         if (response.status === 200 || response.status === 201) {
//           dispatch(toggleNetworkRequestStatus(false));
//           if (response.data.status === 200) {
//              dispatch(leadStatusDataSuccess(response.data.data)); 
//           }
//         }
//       })
//       .catch((error) => { 
//         dispatch(toggleNetworkRequestStatus(false));
//         throw error;
//       });
//   };
// }

const leadStatusData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LEAD_STATUS, params);
      } else {
        response = await agent.post(API.GET_LEAD_STATUS, params);
        
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(leadStatusDataSuccess(response.data.data));
          }
        }
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

// leadType
// const leadStatusDataAll = (params, preloader = true, returnVal = false) => {
//   return async function (dispatch) {
//     if (preloader) {
//       dispatch(toggleNetworkRequestStatus(true));
//     } 
//     try {
//       let response;

//       if (returnVal) {
//         response = await agent.post(API.GET_LEAD_STATUS_ALL, params);
//       } else {
//         response = await agent.post(API.GET_LEAD_STATUS_ALL, params);
        
//         if (response.status === 200 || response.status === 201) {
//           if (response.data.status === 200) {
//             dispatch(leadStatusDataSuccess(response.data.data));
//           }
//         }
//       }

//       if (preloader) {
//         dispatch(toggleNetworkRequestStatus(false));
//       }

//       return response;
//     } catch (error) {
//       // Handle errors, e.g., log or dispatch an error action
//       console.error("API Request Error:", error);

//       if (preloader) {
//         dispatch(toggleNetworkRequestStatus(false));
//       } 
//       throw error;
//     }
//   };
// };

/* const checklistsData  = (params) => {
  return async function (dispatch) { 
    dispatch(toggleNetworkRequestStatus(true));
    await agent
      .post(API.GET_CHECKLISTS, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(toggleNetworkRequestStatus(false));
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(checklistsDataSuccess(response.data.data));
           }
        }
      })
      .catch((error) => { 
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      });
  };
} */

const checklistsData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_CHECKLISTS, params);
      } else {
        response = await agent.post(API.GET_CHECKLISTS, params);
        
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(checklistsDataSuccess(response.data.data));
          }
        }
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const checklistInfo  = (params) => {
  return async function (dispatch) { 
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.GET_CHECKLISTS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const createLeadProfile = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_LEAD_PROFILE, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const leadProfileInfo  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_LEAD_PROFILE, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(leadProfileInfoSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
}

const createSourceLead = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_SOURCE_LEAD, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const sourceLeadInfo  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_SOURCE_OF_LREADS, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(sourceLeadInfoSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
}

const updateLeadChecklistQuestionAnswer = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPDATE_LEAD_CHECKLIST_QUESTION_ANSWER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}


const createLeadStatus = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_LEAD_STATUS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const leadStatusInfo  = (params) => {
  return async function (dispatch) { 
    await agent
      .post(API.GET_LEAD_STATUS, params)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            // console.log(response.data.data);
            dispatch(leadStatusInfoSuccess(response.data.data)); 
          }
        }
      })
      .catch((error) => { 
        throw error;
      });
  };
}

const updateLeadKarzaPanDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPDATE_LEAD_PAN_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const updateLeadAgreementNoDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPDATE_LEAD_AGREEMENT_NO_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addClientHabileInfo = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_CLIENT_HABILE_INFO, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addIdentifierHabileInfo = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_IDENTIFIER_HABILE_INFO, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addSummaryInfo = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_SUMMARY_INFO, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const callCrifAPI = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CALL_CRIF_API, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const masterStatesData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_STATES, params);
      } else {
        response = await agent.post(API.GET_STATES, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const addCredit = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_CREDIT, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const getNoteHistory = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_NOTE_HISTORY, params);
      } else {
        response = await agent.post(API.GET_NOTE_HISTORY, params);       
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const masterPrefillTemplateTypeData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_PREFILL_TEMPLATE_TYPE, params);
      } else {
        response = await agent.post(API.GET_PREFILL_TEMPLATE_TYPE, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const masterPrefillTemplateNameData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_PREFILL_TEMPLATE_NAME, params);
      } else {
        response = await agent.post(API.GET_PREFILL_TEMPLATE_NAME, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const addEditPrefillTemplateName = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_PREFILL_TEMPLATE_NAME, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const deleteLeadBasicInfo = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.DELETE_LEAD_BASIC_INFO, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const uploadLeads = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPLOAD_LEADS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const uploadLeadData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_UPLOAD_LEAD, params);
      } else {
        response = await agent.post(API.GET_UPLOAD_LEAD, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const masterDocumentTypeData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_DOCUMENT_TYPE, params);
      } else {
        response = await agent.post(API.GET_DOCUMENT_TYPE, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const addEditDocumentTypeData = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_DOCUMENT_TYPE, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const getUploadLeadDocument = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_UPLOAD_LEAD_DOCUMENT, params);
      } else {
        response = await agent.post(API.GET_UPLOAD_LEAD_DOCUMENT, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const addEditLeadDocument = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPLOAD_LEAD_DOCUMENT, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const getCrifReport = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.VIEW_CRIF_REPORT, params);
      } else {
        response = await agent.post(API.VIEW_CRIF_REPORT, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const exportLeadScoreCard = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.EXPORT_LEAD_SCORE_CARD, params);
      } else {
        response = await agent.post(API.EXPORT_LEAD_SCORE_CARD, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const storeScoreData = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.STORE_SCORE_DATA, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addEditLeadAllCloudCustomer = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.MANAGE_LEAD_ALLCLOUD_CUSTOMER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addEditAllCloudCustomerLead = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.MANAGE_ALLCLOUD_CUSTOMER_LEAD, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addEditAllCloudCustomerLoan = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.MANAGE_ALLCLOUD_CUSTOMER_LOAN, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const validateBefiscPhoneDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.VALIDATE_BEFISC_PHONE_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const sendEnachUPIRegistrationDetails = (params) => {
  console.log("paramsLeadActions", params)
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.SEND_ENACH_UPI_REGISTRATION_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}


const sendEnachRegistrationDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.SEND_ENACH_REGISTRATION_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const enachActionsDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ENACH_ACTIONS_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const updateFiChecklistQuestionAnswer = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPDATE_FI_CHECKLIST_QUESTION_ANSWER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const aadharValidation = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.AADHAR_VALIDATION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const manageCAMDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.MANAGE_CAM_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false)); 
      throw error;
    } 
  };
}

const getCAMDetails = (params) => { 
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.GET_CAM_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const addCamApprovalAction = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_CAM_APPROVAL_ACTION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const leadFlowReport = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.LEAD_FLOW_REPORT, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const leadFlowOtherDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.LEAD_FLOW_OTHER_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const verifyDocuments = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.VERIFY_DOCUMENTS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false)); 
      throw error;
    } 
  };
}

const getSanctionConfigData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_SANCTION_CONFIG_DATA, params);
      } else {
        response = await agent.post(API.GET_SANCTION_CONFIG_DATA, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
 
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const masterDealersData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_DEALERS, params);
      } else {
        response = await agent.post(API.GET_DEALERS, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};
 
const addEditDealerData = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_DEALER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const masterLocationsData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LOCATIONS, params);
      } else {
        response = await agent.post(API.GET_LOCATIONS, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const addEditLocationsData = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_LOCATIONS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const sendRazorpayRegistrationDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.SEND_RAZORPAY_REGISTRATION_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const masterAllData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try { 
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_MASTERS, params);
      } else {
        response = await agent.post(API.GET_MASTERS, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const getApplicationDetailsData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_APPLICATION_DETAILS_DATA, params);
      } else {
        response = await agent.post(API.GET_APPLICATION_DETAILS_DATA, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
 
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const aadharDigiLockerValidation = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.AADHAR_DIGILOCKER_VALIDATION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const getAadharDetailsDigiLocker = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(false));
    try {
      const response = await agent.post(API.GET_AADHAR_DETAILS_DIGILOCKER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const callLeadVivritiApis = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CALL_LEAD_VIVRITI_APIS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const loanPaymentAttachments = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.LOAN_PAYMENT_ATTACHMENTS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const updatePaymentLoanDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPDATE_PAYMENT_LOAN_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const validateToolsDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.VALIDATE_TOOLS_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const uploadTempFile = (params, axiosConfig = {}) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.UPLOAD_TEMP_FILE, params, {
    headers: {
      'Content-Type': 'application/json',
    },
    ...axiosConfig,  // ✅ support progress tracking
  });
      dispatch(toggleNetworkRequestStatus(false));
      return response.data;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    }
  };
};

const saveLeadPDDData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.SAVE_PDD_DATA, params);
      } else {
        response = await agent.post(API.SAVE_PDD_DATA, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
 
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const saveRSMRHCHDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.SAVE_RSM_RH_CH_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const saveReFIReviewDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.SAVE_RE_FI_REVIEW_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const aadharTimbleDigiLockerValidation = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.AADHAR_TIMBLE_DIGILOCKER_VALIDATION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const getAadharTimbleDetailsDigiLocker = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(false));
    try {
      const response = await agent.post(API.GET_AADHAR_TIMBLE_DETAILS_DIGILOCKER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const verifyCollectiveOverDue = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.VERIFY_COLLECTIVE_OVERDUE, params);
      } else {
        response = await agent.post(API.VERIFY_COLLECTIVE_OVERDUE, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

const ckycActionCall = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CKYC_ACTION_CALL, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false)); 
      throw error;
    } 
  };
}

const getCkycDetails = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.GET_CKYC_DETAILS, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false)); 
      throw error;
    } 
  };
}

const addCamCustomerDedupeAction = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.ADD_CAM_CUSTOMER_DEDUPE_ACTION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const postEsignAgreement = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.POST_ESIGN_AGREEMENT, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const downloadEsignAgreement = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.DOWNLOAD_ESIGN_AGREEMENT, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const agreementEsignOtherAction = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.AGREEMENT_ESIGN_OTHER_ACTION, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}

const masterSubDealersData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_SUB_DEALERS, params);
      } else {
        response = await agent.post(API.GET_SUB_DEALERS, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
      console.error("API States Request Error:", error);

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};
 
const addEditSubDealerData = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CREATE_SUB_DEALER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    } 
  };
}


const getLoanNOCDetailsData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) {
      dispatch(toggleNetworkRequestStatus(true));
    } 
    try {
      let response;

      if (returnVal) {
        response = await agent.post(API.GET_LOAN_NOC_DETAILS_DATA, params);
      } else {
        response = await agent.post(API.GET_LOAN_NOC_DETAILS_DATA, params);
        
      }

      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      }

      return response;
    } catch (error) {
      // Handle errors, e.g., log or dispatch an error action
 
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(false));
      } 
      throw error;
    }
  };
};

export default {
  createLead,
  editLead,
  addEditLead,
  createLeadCommunication,
  sourceOfLeadDataSuccess,
  sourceData,
  masterProfileDataSuccess,
  masterProfileData,
  createLeadQualificationChecklist,
  leadsData,
  leadsDataSuccess,
  leadInfo,
  leadInfoSuccess,
  leadChecklistDataSuccess,
  leadChecklistData,
  leadCommunicationInfo,
  interactionTypeData,
  leadStatusDataSuccess,
  leadStatusData,
  // leadStatusDataAll,
  leadStatusDataAllDropdown,
  createQualificationChecklist,
  checklistsData,
  checklistsDataSuccess,
  checklistInfo,
  createLeadProfile,
  leadProfileInfo,
  createSourceLead,
  sourceLeadInfo,
  updateLeadChecklistQuestionAnswer,
  createLeadStatus,
  leadStatusInfo,
  leadStatusInfoSuccess,
  updateLeadKarzaPanDetails,
  addClientHabileInfo,
  addIdentifierHabileInfo,
  addSummaryInfo,
  callCrifAPI,
  masterStatesData,
  addCredit,
  getNoteHistory,
  masterPrefillTemplateTypeData,
  masterPrefillTemplateNameData,
  addEditPrefillTemplateName,
  deleteLeadBasicInfo,
  uploadLeads,
  uploadLeadData,
  masterDocumentTypeData,
  addEditDocumentTypeData,
  getUploadLeadDocument,
  addEditLeadDocument,
  getCrifReport,
  exportLeadScoreCard,
  storeScoreData,
  addEditLeadAllCloudCustomer,
  addEditAllCloudCustomerLead,
  addEditAllCloudCustomerLoan,
  validateBefiscPhoneDetails,
  sendEnachUPIRegistrationDetails,
  sendEnachRegistrationDetails,
  // leadInfoSuccess,
  enachActionsDetails,
  updateFiChecklistQuestionAnswer,
  aadharValidation,
  manageCAMDetails,
  getCAMDetails,
  addCamApprovalAction,
  leadFlowReport,
  leadFlowOtherDetails,
  verifyDocuments,
  getSanctionConfigData,
  masterDealersData,
  addEditDealerData,
  sendRazorpayRegistrationDetails,
  masterAllData,
  updateLeadAgreementNoDetails,
  masterLocationsData,
  addEditLocationsData,
  getApplicationDetailsData,
  aadharDigiLockerValidation,
  getAadharDetailsDigiLocker,
  callLeadVivritiApis,
  loanPaymentAttachments,
  updatePaymentLoanDetails,
  validateToolsDetails,
  uploadTempFile,
  saveLeadPDDData,
  saveRSMRHCHDetails,
  aadharTimbleDigiLockerValidation,
  getAadharTimbleDetailsDigiLocker,
  verifyCollectiveOverDue,
  saveReFIReviewDetails,
  ckycActionCall,
  getCkycDetails,
  addCamCustomerDedupeAction,
  postEsignAgreement,
  downloadEsignAgreement,
  agreementEsignOtherAction,
  masterSubDealersData,
  addEditSubDealerData,
  getLoanNOCDetailsData,
}